import { render, staticRenderFns } from "./ModalTransportTreatment.vue?vue&type=template&id=5f530689&scoped=true&"
import script from "./ModalTransportTreatment.vue?vue&type=script&lang=js&"
export * from "./ModalTransportTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f530689",
  null
  
)

export default component.exports